export default function replaceCollapsibleButtonText () {
    const $collapsibleHeader = $('.collapsible-header')
    const $collapsibleButton = $('.collapsible-header .paragraph')

    function collapseContent() {
        const labelMore = $collapsibleButton.data('more')
        const labelLess = $collapsibleButton.data('less')
        if ($collapsibleHeader.hasClass('active')) {
            $collapsibleButton.html(labelMore)
        } else {
            $collapsibleButton.html(labelLess)
        }
    }

    $collapsibleButton.click(collapseContent)
}


// WEBPACK FOOTER //
// ./Private/Scripts/modules/replaceCollapsibleButtonText.js